import { put, takeLatest, fork, call } from "redux-saga/effects";
import {
  ActionType,
  IDashboardInfoResponse,
} from "models/dashboard/dashboardInfo";
import { httpStatus } from "configs/httpStatus";
import { getDashboardInfo } from "services/dashboard";
import { handleSuccessAction, handleErrorAction } from "./dashboardInfoActions";

function* getDashboardInfoSaga({ payload }: { payload: any }) {
  try {
    const response: IDashboardInfoResponse = yield call(
      getDashboardInfo,
      payload
    );
    if (response.status === httpStatus.StatusOK) {
      yield put(handleSuccessAction(response));
    } else if (
      response.status === httpStatus.StatusUnauthorized ||
      response.status === httpStatus.StatusForbidden
    ) {
      yield put(handleErrorAction(response.message || ""));
    } else {
      yield put(handleErrorAction(response.message || ""));
    }
  } catch (error) {
    yield put(handleErrorAction("error"));
  }
}
function* onGetDashboardInfoWatcher() {
  yield takeLatest(ActionType.DASHBOARD_INFO as any, getDashboardInfoSaga);
}

export default [fork(onGetDashboardInfoWatcher)];
